import * as React from "react";
import { ContentTabs } from "@grandvisionhq/common";
import { Container } from "@grandvisionhq/elements";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
const CmsLinkList = ({ content }) => {
  const links = useBloomreachLinks(
    content.iconLinkCompoundList.map(({ link }) => ({ ...link, url: link.url || "#" }))
  );
  return /* @__PURE__ */ React.createElement(Container, { "data-t": "link-list" }, /* @__PURE__ */ React.createElement(ContentTabs, { links }));
};
const CmsLinkList$1 = compose(
  withBreakpointVisibility,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsLinkList);
export {
  CmsLinkList,
  CmsLinkList$1 as default
};
//# sourceMappingURL=LinkList.js.map
